module.exports = __webpack_public_path__ + "img/TABLE.c411a5ad.svg";